import '../styles/page-home.scss';
import Swiper from '../js/vendor/swiper/swiper.min';
import initAdvisorReviews from './scripts/advisor-reviews';
//Service package slider
let packageSwiper = new Swiper('.package-slider', {
	watchOverflow: true, // hide the arrows when all packages fit
	slidesPerView: 4,
	spaceBetween: 15,
	keyboard: true,
	allowTouchMove: true,
	mousewheel: false,
	simulateTouch: true,
	observer: true,
	observeParents: true,
	passiveListeners: true,
	// Swiper 4: breakpoints are max-width. Whole cards from 900px; below that the
	// same settings as "Hur kan vi hjälpa dig?" so the cards get the same width
	breakpoints: {
		1199: { slidesPerView: 3, spaceBetween: 15 },
		899: { slidesPerView: 2, spaceBetween: 15 },
		719: { slidesPerView: 2.3, spaceBetween: 15 },
		576: { slidesPerView: 1.3, spaceBetween: 15, slidesOffsetBefore: 10, slidesOffsetAfter: 10 },
	},
	navigation: {
		nextEl: '.swiper-button-next-package',
		prevEl: '.swiper-button-prev-package',
	}
});

let helpSwiper = new Swiper('.help-section__container', {
	updateOnWindowResize: true,
	slidesPerView: 3,
	spaceBetween:15,
	grabCursor: true,
	keyboard: false,
	allowTouchMove: false,
	mousewheel: false,
	simulateTouch:false,
	observer: true,
	observeParents: true,
	passiveListeners: true,
	breakpoints: {
		1200: {
			slidesPerView: 3,
			grabCursor: false,
			keyboard: false,
			allowTouchMove: false,
			mousewheel: false,
			simulateTouch:false,
		},
		719: {
			slidesPerView: 2.3,
			grabCursor: false,
			keyboard: false,
			allowTouchMove: false,
			mousewheel: false,
			simulateTouch:false,
			centeredSlides:false,
			navigation: {
				nextEl: '.swiper-button-next-help',
				prevEl: '.swiper-button-prev-help',
			}
		},
		576: {
			slidesPerView: 1.3,
			slidesOffsetBefore:10,
			slidesOffsetAfter:10,
			grabCursor: true,
			keyboard: true,
			allowTouchMove: true,
			mousewheel: true,
			simulateTouch:true,
			navigation: {
				nextEl: '.swiper-button-next-help',
				prevEl: '.swiper-button-prev-help',
			}
		}
	}
});

// Advisor review slider (parts/advisor-reviews-slider.php)
initAdvisorReviews();
